(function () {
    'use strict';

    angular
        .module('app')
        .controller('MessageListDialogCtrl', MessageListDialogCtrl);

    MessageListDialogCtrl.$inject = ['DialogInstance', 'title', 'messages', 'error'];

    /**
     * @ngdoc Controller
     * @description
     * Dialog for showing a list of messages
     */
    function MessageListDialogCtrl(DialogInstance, title, messages, error) {
        /* jshint validthis:true */
        var vm = this;
        vm.close = close;
        vm.title = title;
        vm.messages = messages;

        activate();

        function activate() {
            if (!_.isNil(error)) {
                if (_.isNil(vm.messages)) {
                    vm.messages = [];
                }

                _.forEach(_.unique(generateErrorMessageList(error)), function (formattedError) {
                    vm.messages.push(formattedError);
                });
            }
        }

        function generateErrorMessageList(error)
        {
            var result = [];

            angular.forEach(error, function (errorList) {
                angular.forEach(errorList, function (fieldError) {
                    if (!_.isNil(fieldError.$submitted)) {
                        result = result.concat(generateErrorMessageList(fieldError.$error));
                    } else {
                        var errorText = fieldError.$name + ' is invalid.';

                        if (!_.isNil(fieldError.$error) && fieldError.$error.required) {
                            errorText = fieldError.$name + ' is required.';
                        } else if (!_.isNil(fieldError.$error) && fieldError.$error.formatValid) {
                            errorText = fieldError.$name + ' format is invalid.';
                        } else if (!_.isNil(fieldError.$error) && fieldError.$error.userValid) {
                            errorText = fieldError.$name + ' contains invalid user(s).';
                        }

                        result.push(errorText);
                    }
                });
            });

            return result;
        }

        function close() {
            DialogInstance.ok();
        }
    }
})();
